import { get, isEmpty } from 'lodash'
import store from './store'

export const auth = {
  authenticated() {
    return !isEmpty(get(store, 'state.user.profile'))
  },
}
